/**
 * Log Activity manifest — `log-activity` action.
 *
 * Walks any source → contact. Opens log-activity modal pre-loaded with the
 * resolved contact AND a reference to the original source entity (so the
 * activity is linked to both — e.g. logged against contact + deal).
 *
 * For deals: walks deal → company → contact (pick).
 */

import { MODAL_IDS } from "@west-tennessee-consulting/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "log-activity",
  label: "Log activity",
  primaryEntity: "contact",
  requires: {
    entity: "contact",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.messages.logActivity, {
      contactId: resolved.targetIds[0],
      contactIds: resolved.targetIds,
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
